import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "space-y-6" }
const _hoisted_2 = { class: "flex flex-row flex-wrap gap-y-4 px-4" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "pr-6" }, [
  /*#__PURE__*/_createVNode("hr")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_Select = _resolveComponent("Select")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_DataWrapper, {
        label: "Tipe Komisi",
        class: "w-5/12 pr-8"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_LpInput, {
            modelValue: _ctx.configForwardCommission.commissionType,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.configForwardCommission.commissionType = $event)),
            disabled: true
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_DataWrapper, {
        label: "Acuan Komisi",
        class: "w-5/12"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_LpInput, {
            modelValue: _ctx.commisionReference,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.commisionReference = $event)),
            disabled: true
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_DataWrapper, {
        label: "Parameter",
        class: "w-5/12 pr-8"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Select, {
            class: "w-full my-1.5",
            dataSelect: _ctx.parameterData,
            onOpenSelect: _ctx.onOpenParameterSelect,
            onCloseSelect: _ctx.onCloseParameterSelect,
            isOpenMenu: _ctx.parameterSelect,
            onChooseSelect: _ctx.onSelectParameter,
            longTrim: 30,
            value: _ctx.configForwardCommission.commissionParameter
          }, null, 8, ["dataSelect", "onOpenSelect", "onCloseSelect", "isOpenMenu", "onChooseSelect", "value"])
        ]),
        _: 1
      }),
      _createVNode(_component_DataWrapper, {
        label: "Komisi",
        class: "w-5/12"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_LpInput, {
            modelValue: 
            _ctx.detailData.configurablePriceForwardBookingCommission.commission
          ,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (
            _ctx.detailData.configurablePriceForwardBookingCommission.commission
           = $event)),
            format: _ctx.formatCommissionAmount,
            suffix: "%"
          }, null, 8, ["modelValue", "format"])
        ]),
        _: 1
      })
    ]),
    _hoisted_3
  ]))
}